import { useEffect, useRef } from 'react'
import Phaser from 'phaser'
import { useGameStore } from '../stores/gameStore'
import { BootScene } from '../scenes/BootScene'
import { GameScene } from '../scenes/GameScene'
import HUD from './HUD'
import PuzzlePanel from './PuzzlePanel'
import SequencePuzzlePanel from './SequencePuzzlePanel'
import LogicPuzzlePanel from './LogicPuzzlePanel'
import DebugPuzzlePanel from './DebugPuzzlePanel'
import GameOver from './GameOver'
import AIContextMenu from './AIContextMenu'

export default function Game() {
  const gameRef = useRef<Phaser.Game | null>(null)
  const containerRef = useRef<HTMLDivElement>(null)
  const { leaveRoom, activePuzzle, closePuzzle, gameOverData } = useGameStore()

  useEffect(() => {
    if (!containerRef.current || gameRef.current) return

    const config: Phaser.Types.Core.GameConfig = {
      type: Phaser.AUTO,
      parent: containerRef.current,
      width: window.innerWidth,
      height: window.innerHeight,
      backgroundColor: '#0A2E36',
      physics: {
        default: 'arcade',
        arcade: {
          gravity: { x: 0, y: 0 },
          debug: false,
        },
      },
      scene: [BootScene, GameScene],
      scale: {
        mode: Phaser.Scale.RESIZE,
        autoCenter: Phaser.Scale.CENTER_BOTH,
      },
    }

    gameRef.current = new Phaser.Game(config)

    // Cleanup
    return () => {
      if (gameRef.current) {
        gameRef.current.destroy(true)
        gameRef.current = null
      }
    }
  }, [])

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      if (gameRef.current) {
        gameRef.current.scale.resize(window.innerWidth, window.innerHeight)
      }
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div className="w-full h-full relative">
      {/* Phaser canvas container */}
      <div ref={containerRef} className="absolute inset-0" />

      {/* React HUD overlay */}
      <HUD />

      {/* AI Context Menu */}
      <AIContextMenu />

      {/* Puzzle panel - render correct type */}
      {activePuzzle && activePuzzle.type === 'pattern' && (
        <PuzzlePanel puzzle={activePuzzle as any} onClose={closePuzzle} />
      )}
      {activePuzzle && activePuzzle.type === 'sequence' && (
        <SequencePuzzlePanel puzzle={activePuzzle as any} onClose={closePuzzle} />
      )}
      {activePuzzle && activePuzzle.type === 'logic' && (
        <LogicPuzzlePanel puzzle={activePuzzle as any} onClose={closePuzzle} />
      )}
      {activePuzzle && activePuzzle.type === 'debug' && (
        <DebugPuzzlePanel puzzle={activePuzzle as any} onClose={closePuzzle} />
      )}

      {/* Game over screen */}
      {gameOverData && (
        <GameOver data={gameOverData} />
      )}

      {/* Exit button */}
      <button
        onClick={leaveRoom}
        className="absolute top-4 right-4 px-3 py-1 bg-gray-800/80 text-gray-400 rounded
                   hover:text-red-400 hover:bg-gray-800 transition-colors z-50"
      >
        Wyjdz
      </button>
    </div>
  )
}
